import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import * as langs from '@assets/i18n';

export class AppTranslateLoader implements TranslateLoader {
  /**
   * Gets the translations
   */
  public getTranslation(lang: string): Observable<TranslationObject> {
    const translation = Object.entries(langs).find(([key]) => key === lang)?.[1] as TranslationObject;
    return of(translation);
  }
}
